// Three D&D 5e starter shops. Items reference catalog entries by name; price
// is in copper (base unit) using SRD values from the user's gear-list PDF
// plus standard 5e weapon/armor prices. Anything new the shops sell should
// already exist in INVENTORY_CATALOG (with weight + description).

import { INVENTORY_CATALOG, catalogLookup } from './inventory';

export const SHOPS = {
  general: {
    id: 'general',
    name: 'General Store',
    icon: '🏪',
    description: 'Adventuring gear, supplies, and everyday tools.',
    defaultShopkeeperName: 'Goods & Sundries',
    items: [
      { name: 'Backpack',                 priceCp: 200 },
      { name: 'Bedroll',                  priceCp: 100 },
      { name: 'Mess kit',                 priceCp: 20  },
      { name: 'Tinderbox',                priceCp: 50  },
      { name: 'Torch',                    priceCp: 1   },
      { name: 'Candle',                   priceCp: 1   },
      { name: 'Hooded lantern',           priceCp: 500 },
      { name: 'Bullseye lantern',         priceCp: 1000 },
      { name: 'Oil flask',                priceCp: 10  },
      { name: 'Rations (1 day)',          priceCp: 50  },
      { name: 'Waterskin',                priceCp: 20  },
      { name: 'Pot, iron',                priceCp: 200 },
      { name: 'Rope (50ft, hempen)',      priceCp: 100 },
      { name: 'Rope (50ft, silk)',        priceCp: 1000 },
      { name: 'Grappling hook',           priceCp: 200 },
      { name: 'Piton',                    priceCp: 5   },
      { name: "Climber's kit",            priceCp: 2500 },
      { name: 'Hammer',                   priceCp: 100 },
      { name: 'Crowbar',                  priceCp: 200 },
      { name: 'Shovel',                   priceCp: 200 },
      { name: 'Tent, two-person',         priceCp: 200 },
      { name: 'Lock',                     priceCp: 1000 },
      { name: 'Manacles',                 priceCp: 200 },
      { name: 'Spyglass',                 priceCp: 100000 },
      { name: 'Magnifying glass',         priceCp: 10000 },
      { name: "Clothes, traveler's",      priceCp: 200 },
      { name: 'Clothes, common',          priceCp: 50  },
      { name: 'Whetstone',                priceCp: 1   },
      { name: 'Bell',                     priceCp: 100 },
      { name: "Healer's kit",             priceCp: 500 },
      { name: 'Hourglass',                priceCp: 2500 },
      { name: 'Mirror, steel',            priceCp: 500 },
      { name: 'Sack',                     priceCp: 1   },
      { name: 'Pouch',                    priceCp: 50  },
      { name: 'Chest',                    priceCp: 500 },
      { name: "Thieves' tools",           priceCp: 2500 },
      { name: 'Disguise kit',             priceCp: 2500 },
      { name: "Navigator's tools",        priceCp: 2500 },
    ],
  },
  smithy: {
    id: 'smithy',
    name: 'Smithy',
    icon: '⚒',
    description: 'Weapons, armor, ammunition, and craft tools.',
    defaultShopkeeperName: 'The Iron Forge',
    items: [
      // Simple weapons
      { name: 'Dagger',                   priceCp: 200 },
      { name: 'Handaxe',                  priceCp: 500 },
      { name: 'Spear',                    priceCp: 100 },
      { name: 'Quarterstaff',             priceCp: 20  },
      { name: 'Mace',                     priceCp: 500 },
      { name: 'Light crossbow',           priceCp: 2500 },
      { name: 'Shortbow',                 priceCp: 2500 },
      // Martial weapons
      { name: 'Shortsword',               priceCp: 1000 },
      { name: 'Longsword',                priceCp: 1500 },
      { name: 'Greatsword',               priceCp: 5000 },
      { name: 'Rapier',                   priceCp: 2500 },
      { name: 'Scimitar',                 priceCp: 2500 },
      { name: 'Battleaxe',                priceCp: 1000 },
      { name: 'Greataxe',                 priceCp: 3000 },
      { name: 'Warhammer',                priceCp: 1500 },
      { name: 'Morningstar',              priceCp: 1500 },
      { name: 'Heavy crossbow',           priceCp: 5000 },
      { name: 'Longbow',                  priceCp: 5000 },
      // Armor
      { name: 'Padded',                   priceCp: 500 },
      { name: 'Leather',                  priceCp: 1000 },
      { name: 'Studded leather',          priceCp: 4500 },
      { name: 'Hide',                     priceCp: 1000 },
      { name: 'Chain shirt',              priceCp: 5000 },
      { name: 'Scale mail',               priceCp: 5000 },
      { name: 'Breastplate',              priceCp: 40000 },
      { name: 'Half plate',               priceCp: 75000 },
      { name: 'Chain mail',               priceCp: 7500 },
      { name: 'Plate',                    priceCp: 150000 },
      { name: 'Shield',                   priceCp: 1000 },
      // Ammunition + craft tools
      { name: 'Arrows ×20',               priceCp: 100 },
      { name: 'Bolts ×20',                priceCp: 100 },
      { name: 'Quiver',                   priceCp: 100 },
      { name: "Smith's tools",            priceCp: 2000 },
      { name: "Carpenter's tools",        priceCp: 800 },
      { name: "Mason's tools",            priceCp: 1000 },
    ],
  },
  alchemist: {
    id: 'alchemist',
    name: 'Alchemist',
    icon: '🧪',
    description: 'Potions, vials, focuses, and alchemical supplies.',
    defaultShopkeeperName: "The Mixer's Stall",
    items: [
      { name: 'Healing potion',           priceCp: 5000 },
      { name: 'Antitoxin',                priceCp: 5000 },
      { name: 'Acid (vial)',              priceCp: 2500 },
      { name: "Alchemist's fire",         priceCp: 5000 },
      { name: 'Holy water',               priceCp: 2500 },
      { name: 'Oil flask',                priceCp: 10  },
      { name: 'Component pouch',          priceCp: 2500 },
      { name: 'Crystal (arcane focus)',   priceCp: 1000 },
      { name: 'Orb (arcane focus)',       priceCp: 2000 },
      { name: 'Rod (arcane focus)',       priceCp: 1000 },
      { name: 'Wand (arcane focus)',      priceCp: 1000 },
      { name: 'Sprig of mistletoe (druidic)', priceCp: 100 },
      { name: 'Holy symbol',              priceCp: 500 },
      { name: 'Spellbook',                priceCp: 5000 },
      { name: "Alchemist's supplies",     priceCp: 5000 },
      { name: 'Herbalism kit',            priceCp: 500 },
      { name: "Poisoner's kit",           priceCp: 5000 },
      { name: 'Ink (1 oz bottle)',        priceCp: 1000 },
      { name: 'Vial',                     priceCp: 100 },
    ],
  },
};

export function getShop(shopId) {
  return SHOPS[shopId] || null;
}

export function getShopItem(shopId, itemName) {
  const shop = SHOPS[shopId];
  if (!shop) return null;
  return shop.items.find((i) => i.name === itemName) || null;
}

// Merge a shop entry's price with the catalog row's full data so callers can
// render name / description / weight / category alongside the price.
export function describeShopItem(shopId, itemName) {
  const shopItem = getShopItem(shopId, itemName);
  if (!shopItem) return null;
  const catalog = catalogLookup(itemName);
  if (!catalog) return null;
  return { ...catalog, priceCp: shopItem.priceCp };
}

export const SHOP_LIST = Object.values(SHOPS);
